import type { CamProfile } from './followCamera.ts';

/** The combat lens looks into the water arena, with enough width for a fully grown stern. */
export function seaCombatCamera(base: CamProfile, aspect: number, overview: boolean): CamProfile {
  if (overview) return base;
  const portrait = Math.max(0, Math.min(1, (1 - (Number.isFinite(aspect) ? aspect : 1)) / 0.55));
  return {
    ...base,
    dist: base.dist + 0.9 + portrait * 0.85,
    height: base.height + 1.2 + portrait * 0.15,
    lookAhead: Math.min(base.lookAhead, 3.4),
    lookUp: Math.min(base.lookUp, 0.55),
    speedDist: Math.min(base.speedDist ?? 0, 0.6),
    lead: Math.min(base.lead, 0.2),
  };
}
